// extracted by mini-css-extract-plugin
export default {"container":"MainLayout_container__YzzQu","main":"MainLayout_main__i-uQO","main__content":"MainLayout_main__content__cj1sA","close_sidebar":"MainLayout_close_sidebar__8LbbJ"};